module.exports = __webpack_public_path__ + "static/media/Diploma of Project Management.78a6664e.pdf";